// src/components/CategorySection.jsx
// مكون عرض قسم التصنيفات - يعرض المنتجات في شبكة مع عنوان القسم

// استيراد المكتبات والأدوات المطلوبة
import { Container } from "react-bootstrap"; // حاوية Bootstrap للتنسيق
import ProductCard from "./ProductCard"; // مكون بطاقة المنتج
import SectionHeader from "./SectionHeader"; // مكون عنوان القسم

// ================ المكون الرئيسي ================
// مكون عرض المنتجات حسب التصنيف
export default function CategorySection ( { category, products } )
{
    // التحقق من وجود منتجات في القسم
    // إذا كان القسم لا يحتوي على أي منتج، نخفيه بالكامل
    if ( !products || products.length === 0 ) return null;

    return (
        // حاوية Bootstrap مع هوامش علوية وسفلية
        <Container className="mt-5 mb-5">
            {/* عرض عنوان القسم */ }
            <SectionHeader title={ category.title } />

            {/* شبكة المنتجات */ }
            <div className="product-grid">
                {/* عرض كل منتج في بطاقة */ }
                { products.map( ( product ) => (
                    <ProductCard
                        key={ product.id } // مفتاح فريد لكل منتج
                        id={ product.id } // معرف المنتج
                        title={ product.title } // عنوان المنتج
                        description={ product.description } // وصف المنتج
                        img={ product.images && product.images[ 0 ] ? product.images[ 0 ].image : "" } // صورة المنتج (الأولى)
                        price={ product.price } // سعر المنتج
                        discount={ product.discount } // نسبة الخصم
                        rating={ product.rating } // تقييم المنتج
                        sale={ product.sale } // حالة العرض الخاص
                    />
                ) ) }
            </div>
        </Container>
    );
}